import { Card, DataCardCircleProps, CardConfig, CardConfigurations, DataCardHeaderProps, DataCardLegendProps } from '../../../models/internal_api/cardInterfaces.model';
import './DataCard.scss';
import DataCardCircle from './DataCardCircle/DataCardCircle';
import DataCardHeader from './DataCardHeader/DataCardHeader';
import DataCardLegend from './DataCardLegend/DataCardLegend';
import Loading from "../../Elements/Loading";

type DataCardProps = {
    card: Card,
    isLoading: boolean,
}

export default function DataCard({ card, isLoading }: DataCardProps) {
    const config: CardConfigurations = CardConfig.filter((cardConfig: CardConfigurations) => cardConfig.key === card.id)[0];

    const cardTitle: string = card.title;
    const cardHeaderProps: DataCardHeaderProps = {
        config: config,
        title: cardTitle
    };

    const cardCircleProps: DataCardCircleProps = {
        config: config,
        metrics: card.metrics,
        type: card.type
    };

    const cardLegendProps: DataCardLegendProps = {
        metrics: card.metrics,
        type: card.type,
        color: config.circleColor
    };
    if (!isLoading) {
        return (
            <div className='DataCard'>
                <DataCardHeader {...cardHeaderProps} />
                <DataCardCircle {...cardCircleProps} />
                <DataCardLegend {...cardLegendProps} />
            </div>
        );
    }
    else {
        return (
            <div className='DataCard'>
                <Loading></Loading>
            </div>
        );
    }
}
